export default __webpack_public_path__ + "static/media/icon-play-circle.93b12909.svg";